export default __webpack_public_path__ + "static/media/signup-button.f08f5be5.png";